'use strict';

angular.module('internal.licenses')
    .controller('InternalTriggerConfigurationModal', ['$scope', '$uibModalInstance', 'TriggerConfigurations', function ($scope, $uibModalInstance, TriggerConfigurations) {
        $scope.trigger_configuration = {};
        $scope.trigger_configuration.default_flag = false;
        $scope.saving = false;

        $scope.save = function () {
            $scope.saving = true;
            TriggerConfigurations.save($scope.trigger_configuration).then(function(newConfig) {
                $scope.saving = false;
                $uibModalInstance.close(newConfig);
            });
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;